import { DataResponse } from './../services/response';
import { observable, runInAction } from 'mobx';
import { IRoutingServices, RoutingModel, DataInputRouting } from 'services/routing_services';

export type routingStore = {
  routing: {
    data: RoutingModel[];
  };
  createResponse: {
    message: string;
    isSuccess: boolean;
  };
  detailRouting: {
    data: DataInputRouting | undefined;
    message: string;
    isSuccess: boolean;
  };
  updateResponse: {
    message: string;
    isSuccess: boolean;
  };
  searchRoutingResponse: DataResponse<Array<DataInputRouting>>;
};

export interface IRoutingPresenter {
  createStore(): routingStore;
  getListRouting(store: routingStore, keyword?: string): Promise<RoutingModel[] | undefined>;
  // Create routing
  createRouting(store: routingStore, data: DataInputRouting): Promise<void>;
  // Detail routing
  getDetailRouting(store: routingStore, stepId: string): Promise<void | undefined>;
  // Update detail routing
  updateDetailRouting(store: routingStore, data: DataInputRouting): Promise<void>;
  // Search routing
  searchRouting(store: routingStore, data: object): Promise<void>;
  // Export routing
  exportRouting(data: object): Promise<void>;
}

export function createRoutingPresenter({ routingServices }: { routingServices: IRoutingServices }): IRoutingPresenter {
  return {
    createStore: (): routingStore =>
      observable({
        routing: {
          data: [],
        },
        createResponse: {
          message: '',
          isSuccess: false,
        },
        detailRouting: {
          data: undefined,
          message: '',
          isSuccess: false,
        },
        updateResponse: {
          message: '',
          isSuccess: false,
        },
        searchRoutingResponse: {
          data: [],
          paging: {
            totalCount: 0,
            totalPage: 0,
            pageSize: 0,
          },
          message: '',
          isSuccess: false,
        },
      }),
    getListRouting: async (store, keyword) => {
      try {
        const routing = await routingServices.getListRouting(keyword);
        runInAction(() => {
          store.routing.data = routing.data;
        });
        return routing.data;
      } catch (error) {
        console.log(error);
      }
    },
    // Create routing
    createRouting: async (store, data) => {
      try {
        const createRouting = await routingServices.createRouting(data);
        runInAction(() => {
          store.createResponse.isSuccess = createRouting.isSuccess;
          store.createResponse.message = createRouting.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Detail routing
    getDetailRouting: async (store, stepId) => {
      try {
        const detailRouting = await routingServices.getDetailRouting(stepId);
        runInAction(() => {
          store.detailRouting.data = detailRouting.data;
          store.detailRouting.message = detailRouting.message;
          store.detailRouting.isSuccess = detailRouting.isSuccess;
        });
        // return detailRouting.data;
      } catch (error) {
        console.log(error);
      }
    },
    // Update detail routing
    updateDetailRouting: async (store, data) => {
      try {
        const updateDetailRouting = await routingServices.updateDetailRouting(data);
        runInAction(() => {
          store.updateResponse.isSuccess = updateDetailRouting.isSuccess;
          store.updateResponse.message = updateDetailRouting.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Search routing
    searchRouting: async (store, data) => {
      try {
        const result = await routingServices.searchRouting(data);
        runInAction(() => {
          store.searchRoutingResponse.data = result.data;
          store.searchRoutingResponse.isSuccess = result.isSuccess;
          store.searchRoutingResponse.message = result.message;
          store.searchRoutingResponse.paging = {
            totalCount: result.paging?.totalCount,
            totalPage: result.paging?.totalPage,
            pageSize: result.paging?.pageSize,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Export routing
    exportRouting: async (data: object) => {
      try {
        await routingServices.exportRouting(data);
      } catch (error) {
        console.log(error);
      }
    },
  };
}
